module.exports = __webpack_public_path__ + "static/media/module_data_image.4e2d1dc6.png";